
<div class="full-page-container">

  <div class="signup-container d-flex align-items-center justify-content-center">

    <div class="signup-card p-4">
        <div class="logo-container mb-4">
          <img class="prelogin-logo" src="../../../../assets/hubtiger_logo_full.png" (click)="home()">
        </div>

<!--      <h2 class="text-light text-center mb-4">Sign Up</h2>-->
      <div *ngIf="step===1">
        <app-wizard-registration [messageService]="messageService" [country]="country"></app-wizard-registration>
      </div>

      <div *ngIf="step===2">
        <app-wizard-account-verification [messageService]="messageService" [verificationCode]="verificationCode"
                                         (next)="next($event)"></app-wizard-account-verification>
      </div>

      <div *ngIf="step===3">
        <app-wizard-shop-profile [messageService]="messageService" [verificationCode]="verificationCode"
                                 [partner]="partner" (next)="next($event)"></app-wizard-shop-profile>
      </div>

      <div *ngIf="step===4">
        <app-wizard-users [messageService]="messageService" [verificationCode]="verificationCode" [partner]="partner"
                          (next)="next($event)"></app-wizard-users>
      </div>

      <div *ngIf="step===5">
        <app-wizard-link-pos [messageService]="messageService" [verificationCode]="verificationCode"
                             [partner]="partner" (next)="next($event)"></app-wizard-link-pos>
      </div>

      <div *ngIf="step===6">
        <app-wizard-service-types [messageService]="messageService" [verificationCode]="verificationCode"
                                  [partner]="partner" (next)="next($event)"></app-wizard-service-types>
      </div>

    </div>
  </div>
</div>


